import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
export function initLogo(logo = 'LogoJewel') {
    const logoStore = writable(logo);
    setContext('LOGO', logoStore);
    return logoStore;
}
export function getLogo() {
    return getContext('LOGO') || writable('LogoJewel');
}
